import React from 'react'
import styled from 'styled-components'

import Colors from '../../colors'

export default styled.div`
  h1 {
    font-size: 3rem;
  }
  ul {
    padding: 0;
  
    li {
      color: ${Colors.secondary};
      font-size: 2.3rem;
      margin: 0 20px 15px 0;
      padding: 5px 10px;
      border-radius: 5px;
    }
  }
`;